import { Progress } from "antd";
import styled from "styled-components";

export const StyledDashboardProgress = styled(Progress)<{
    limit: number;
    isOverMax: boolean;
}>`
    width: 100%;
    position: relative;
    .ant-progress-outer {
        position: relative;
        &:before {
            content: "";
            display: ${(props) =>
                props.isOverMax || props.limit >= 100 ? "none" : "block"};
            border-top-left-radius: 100px;
            border-bottom-left-radius: 100px;
            position: absolute;
            top: 0;
            left: 0;
            width: ${(props) => props.limit}%;
            height: 100%;
            background-color: #65a9f3;
            z-index: 0;
        }
    }

    .ant-progress-bg {
        background-color: ${(props) =>
            props.isOverMax ? "#49AA19" : "#1668DC"} !important;
    }

    & span {
        font-size: 10px;
        font-weight: 500;
        line-height: 88%;
        position: relative;
        z-index: 1;
        color: #d9d9d9 !important;
    }
`;
